import { useEffect, useState } from "react";
import { ActivityLogModel } from "../models/ActivityLogModel";
import { useHistory } from "react-router-dom";
import { getActivityLog } from "../../../service/activity_log/ActivityLog";

export const useGetActivityLog = (realoadGrid: number, createdAt: string, collaborator_id: number) => {

  const [list, setList] = useState<ActivityLogModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await getActivityLog(createdAt, collaborator_id)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setList(res);
        setLoadingRequest(false);
      }
    };
    fetchPost();

  }, [realoadGrid, createdAt, collaborator_id]);

  return { list, loadingRequest };
};